export default "__VITE_ASSET__Dtrd7MFo__"